import React from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <div className="lost">
      <Seo
        title="Lost in the Fog | Ninja Athletic Club"
        description="This path does not exist. The way home does."
        path="/404"
        noindex
      />
      <div className="wrap">
        <div className="bigseal">忍</div>
        <h1>
          Lost in <span className="ol">the fog.</span>
        </h1>
        <p>This path does not exist. The way home does. Endure, reset, and walk back to the dojo.</p>
        <Link className="btn wh" to="/">
          Return Home
        </Link>
      </div>
    </div>
  );
}
